module.exports = __webpack_public_path__ + "img/openapi-platform-case-study.b120b560.jpg";